import { useSelector } from 'react-redux';
import { getIsOnVacation } from '@app/redux/customer/selectors';

const useCustomerIsOnVacation = (): boolean =>
  useSelector(getIsOnVacation) as boolean;

export default useCustomerIsOnVacation;
